import { OptionalLink } from '../01-core/OptionalLink';
import { Icon } from './Icon';

export interface ActionProps {
  /** Tag label */
  label: string;
  /** Title on tag */
  title?: string;
  /** Link on tag */
  href?: string;
  /** Action link target */
  target?: '_blank' | '_top';
  /** Optional icon */
  icon?: string;
  /** Render icon after label */
  icon_after?: boolean;
  /** Additional class */
  className?: string;
  /** Optional click handler */
  onClick?: () => void;
}

/** An action link */
export const Action = ({
  label,
  title,
  href,
  target,
  icon,
  icon_after,
  className,
  ...props
}: ActionProps) => {
  const classNames = ['action', className];
  if (icon && icon_after) {
    classNames.push('action--icon-after');
  }
  return (
    <OptionalLink
      button={true}
      type={href ? undefined : 'button'}
      className={classNames.join(' ')}
      href={href}
      target={target}
      title={title}
      {...props}
    >
      {icon && <Icon className="action__icon" icon={icon} />}
      {label}
    </OptionalLink>
  );
};
